import { HTMLAttributes } from "react";

const variants = {
	xsmall: "px-4 lg:px-8 xl:px-0 w-full max-w-[660px] mx-auto",
	small: "px-4 lg:px-8 xl:px-0 w-full max-w-[960px] mx-auto",
	medium: "px-4 lg:px-8 w-full max-w-[1300px] mx-auto",
	large: "px-4 lg:px-8 w-full max-w-[1500px] mx-auto",
	xlarge: "px-4 lg:px-8 w-full max-w-[1600px] mx-auto",
	"no-container": "",
	default: "px-4 md:px-6",
};

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
	children?: any;
	className?: string;
	variant: keyof typeof variants;
}

const Container = ({
	children,
	className,
	variant,
	...rest
}: ContainerProps) => {
	return (
		<div
			{...rest}
			className={`${variants[variant] || ""} ${className || ""}`}
		>
			{children}
		</div>
	);
};

Container.defaultProps = {
	variant: "default",
};

export default Container;
